var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/recording/fixture-schema.ts
var SCHEMA_VERSION = 1;
function createScenario(opts) {
  return {
    schemaVersion: SCHEMA_VERSION,
    name: opts.name,
    device: opts.device,
    deviceId: opts.deviceId,
    capturedAt: (/* @__PURE__ */ new Date()).toISOString(),
    bridgeVersion: opts.bridgeVersion,
    description: opts.description,
    records: []
  };
}
function appendRecord(scenario, record) {
  scenario.records.push(__spreadValues({
    sequence: scenario.records.length
  }, record));
}
function serializeFixture(scenario) {
  validateScenario(scenario);
  const header = {
    schemaVersion: scenario.schemaVersion,
    name: scenario.name,
    device: scenario.device,
    deviceId: scenario.deviceId,
    capturedAt: scenario.capturedAt,
    bridgeVersion: scenario.bridgeVersion,
    description: scenario.description
  };
  const lines = [JSON.stringify(header)];
  for (const record of scenario.records) {
    lines.push(JSON.stringify(record));
  }
  return lines.join("\n") + "\n";
}
function parseFixture(content) {
  const lines = content.split("\n").filter((l) => l.length > 0);
  if (lines.length === 0) {
    throw new Error("parseFixture: empty fixture content");
  }
  const header = parseHeaderLine(lines[0]);
  const records = [];
  for (let i = 1; i < lines.length; i++) {
    const record = parseRecordLine(lines[i], i);
    if (record.sequence !== records.length) {
      throw new Error(
        `parseFixture: sequence gap at line ${i + 1}: expected sequence ${records.length}, got ${record.sequence}`
      );
    }
    records.push(record);
  }
  const scenario = {
    schemaVersion: header.schemaVersion,
    name: header.name,
    device: header.device,
    deviceId: header.deviceId,
    capturedAt: header.capturedAt,
    bridgeVersion: header.bridgeVersion,
    description: header.description,
    records
  };
  return scenario;
}
function parseHeaderLine(line) {
  let raw;
  try {
    raw = JSON.parse(line);
  } catch (err) {
    throw new Error(`parseFixture: header line is not valid JSON: ${err.message}`);
  }
  if (!isObject(raw)) {
    throw new Error("parseFixture: header is not an object");
  }
  if (raw.schemaVersion !== SCHEMA_VERSION) {
    throw new Error(
      `parseFixture: schemaVersion mismatch \u2014 expected ${SCHEMA_VERSION}, got ${String(raw.schemaVersion)}`
    );
  }
  if (typeof raw.name !== "string" || raw.name.length === 0) {
    throw new Error("parseFixture: header.name must be a non-empty string");
  }
  if (raw.device !== "s330" && raw.device !== "s550") {
    throw new Error(`parseFixture: header.device must be 's330' or 's550', got ${String(raw.device)}`);
  }
  if (typeof raw.deviceId !== "number" || raw.deviceId < 0 || raw.deviceId > 15) {
    throw new Error(`parseFixture: header.deviceId must be 0-15, got ${String(raw.deviceId)}`);
  }
  if (typeof raw.capturedAt !== "string") {
    throw new Error("parseFixture: header.capturedAt must be a string");
  }
  return {
    schemaVersion: SCHEMA_VERSION,
    name: raw.name,
    device: raw.device,
    deviceId: raw.deviceId,
    capturedAt: raw.capturedAt,
    bridgeVersion: typeof raw.bridgeVersion === "string" ? raw.bridgeVersion : void 0,
    description: typeof raw.description === "string" ? raw.description : void 0
  };
}
function parseRecordLine(line, lineNum) {
  let raw;
  try {
    raw = JSON.parse(line);
  } catch (err) {
    throw new Error(`parseFixture: line ${lineNum + 1} is not valid JSON: ${err.message}`);
  }
  if (!isObject(raw)) {
    throw new Error(`parseFixture: line ${lineNum + 1} record is not an object`);
  }
  if (typeof raw.sequence !== "number" || !Number.isInteger(raw.sequence) || raw.sequence < 0) {
    throw new Error(`parseFixture: line ${lineNum + 1} sequence must be a non-negative integer`);
  }
  if (raw.kind !== "outbound" && raw.kind !== "inbound") {
    throw new Error(`parseFixture: line ${lineNum + 1} kind must be 'outbound' or 'inbound'`);
  }
  if (!Array.isArray(raw.bytes)) {
    throw new Error(`parseFixture: line ${lineNum + 1} bytes must be an array`);
  }
  for (let b = 0; b < raw.bytes.length; b++) {
    const byte = raw.bytes[b];
    if (typeof byte !== "number" || !Number.isInteger(byte) || byte < 0 || byte > 255) {
      throw new Error(
        `parseFixture: line ${lineNum + 1} byte at index ${b} out of range \u2014 expected 0-255, got ${String(byte)}`
      );
    }
  }
  if (typeof raw.timestampMs !== "number") {
    throw new Error(`parseFixture: line ${lineNum + 1} timestampMs must be a number`);
  }
  const record = {
    sequence: raw.sequence,
    kind: raw.kind,
    bytes: raw.bytes,
    timestampMs: raw.timestampMs
  };
  if (typeof raw.annotation === "string") {
    record.annotation = raw.annotation;
  }
  return record;
}
function validateScenario(scenario) {
  if (scenario.schemaVersion !== SCHEMA_VERSION) {
    throw new Error(
      `serializeFixture: schemaVersion must be ${SCHEMA_VERSION}, got ${scenario.schemaVersion}`
    );
  }
  for (let i = 0; i < scenario.records.length; i++) {
    const r = scenario.records[i];
    if (r.sequence !== i) {
      throw new Error(
        `serializeFixture: record at index ${i} has sequence ${r.sequence} (expected ${i})`
      );
    }
    for (let b = 0; b < r.bytes.length; b++) {
      const byte = r.bytes[b];
      if (!Number.isInteger(byte) || byte < 0 || byte > 255) {
        throw new Error(
          `serializeFixture: record ${i} byte at index ${b} out of range \u2014 expected 0-255, got ${byte}`
        );
      }
    }
  }
}
function isObject(v) {
  return typeof v === "object" && v !== null && !Array.isArray(v);
}

// src/recording/recording-proxy.ts
var RecordingProxyAdapter = class {
  constructor(real, options) {
    this.consumerListeners = [];
    this.realListenerAttached = false;
    /**
     * Single multiplexed listener that the proxy registers with the real
     * adapter. When the device fires inbound, this records the event then
     * fans out to all consumer-registered listeners.
     */
    this.realCallback = (data) => {
      this.captureRecord("inbound", data);
      for (const cb of [...this.consumerListeners]) {
        cb([...data]);
      }
    };
    var _a;
    this.real = real;
    this.clock = (_a = options.clock) != null ? _a : defaultClock();
    this.scenario = createScenario({
      name: options.scenarioName,
      device: options.device,
      deviceId: options.deviceId,
      description: options.description,
      bridgeVersion: options.bridgeVersion
    });
  }
  send(data) {
    this.captureRecord("outbound", data);
    this.real.send(data);
  }
  onSysEx(callback) {
    this.consumerListeners.push(callback);
    if (!this.realListenerAttached) {
      this.real.onSysEx(this.realCallback);
      this.realListenerAttached = true;
    }
  }
  removeSysExListener(callback) {
    const idx = this.consumerListeners.indexOf(callback);
    if (idx >= 0) {
      this.consumerListeners.splice(idx, 1);
    }
  }
  /**
   * Attach an annotation to the NEXT captured record (outbound or inbound).
   * Useful for tagging high-level context — "RQD patch 0", "WSD chunk 3/12" —
   * for fixture readability. Only the immediately next record is annotated;
   * subsequent records remain unannotated unless `annotate()` is called again.
   */
  annotate(text) {
    this.pendingAnnotation = text;
  }
  /**
   * Get the captured scenario. Returns the live reference — callers
   * generally serialise immediately rather than mutating it.
   */
  getScenario() {
    return this.scenario;
  }
  /**
   * Detach the multiplexed listener from the real adapter. Call this when
   * the recording session is complete and the proxy is being discarded
   * (so the real adapter's listener list doesn't grow unbounded across
   * recording sessions).
   */
  detach() {
    if (this.realListenerAttached) {
      this.real.removeSysExListener(this.realCallback);
      this.realListenerAttached = false;
    }
  }
  captureRecord(kind, bytes) {
    const record = {
      kind,
      bytes: [...bytes],
      timestampMs: this.clock()
    };
    if (this.pendingAnnotation !== void 0) {
      record.annotation = this.pendingAnnotation;
      this.pendingAnnotation = void 0;
    }
    appendRecord(this.scenario, record);
  }
};
function defaultClock() {
  const origin = readNow();
  return () => readNow() - origin;
}
function readNow() {
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    return performance.now();
  }
  return Date.now();
}

// src/simulation/simulated-adapter.ts
var SimulatedAdapterUnexpectedSendError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "SimulatedAdapterUnexpectedSendError";
  }
};
var SimulatedAdapterRecordsExhaustedError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "SimulatedAdapterRecordsExhaustedError";
  }
};
var SimulatedAdapter = class {
  constructor(scenario, options) {
    this.cursor = 0;
    this.listeners = [];
    this.scenario = scenario;
    this.latencyMode = options.latencyMode;
  }
  send(data) {
    if (this.cursor >= this.scenario.records.length) {
      throw new SimulatedAdapterRecordsExhaustedError(
        `send([${formatBytes(data)}]) \u2014 fixture "${this.scenario.name}" has no more outbound records (cursor at end of ${this.scenario.records.length} records)`
      );
    }
    const expected = this.scenario.records[this.cursor];
    if (expected.kind !== "outbound") {
      throw new SimulatedAdapterUnexpectedSendError(
        `send([${formatBytes(data)}]) \u2014 fixture "${this.scenario.name}" has no more outbound records at cursor ${this.cursor}; next record is ${expected.kind}`
      );
    }
    const diffIndex = firstByteDiff(expected.bytes, data);
    if (diffIndex !== -1) {
      const expectedByte = diffIndex < expected.bytes.length ? toHex(expected.bytes[diffIndex]) : "<end>";
      const actualByte = diffIndex < data.length ? toHex(data[diffIndex]) : "<end>";
      throw new SimulatedAdapterUnexpectedSendError(
        `send([${formatBytes(data)}]) at sequence ${expected.sequence} does not match recorded outbound [${formatBytes(expected.bytes)}] \u2014 first diff at byte ${diffIndex}: expected ${expectedByte}, got ${actualByte}`
      );
    }
    const outboundTimestamp = expected.timestampMs;
    this.cursor++;
    this.dispatchPendingInbound(outboundTimestamp);
  }
  /**
   * Return the current cursor (number of records consumed so far —
   * both `outbound` records that matched a `send()` call and the
   * subsequent `inbound` records drained by `dispatchPendingInbound`).
   *
   * Capability specs use this to assert their UI driver actually
   * emitted an outbound — without a positive assertion, a UI control
   * that's silently disabled or a click that lands off-target would
   * make the test false-pass (no outbound emitted = no byte mismatch
   * = no error thrown by `send()`).
   */
  getCursor() {
    return this.cursor;
  }
  /**
   * Total record count in the underlying scenario. Paired with
   * `getCursor()`; capability specs assert
   * `cursorAfter === totalRecords` to prove every captured byte was
   * replayed in full.
   */
  getTotalRecords() {
    return this.scenario.records.length;
  }
  onSysEx(callback) {
    this.listeners.push(callback);
  }
  removeSysExListener(callback) {
    const idx = this.listeners.indexOf(callback);
    if (idx >= 0) {
      this.listeners.splice(idx, 1);
    }
  }
  dispatchPendingInbound(referenceTimestamp) {
    while (this.cursor < this.scenario.records.length) {
      const next = this.scenario.records[this.cursor];
      if (next.kind !== "inbound") break;
      const delayMs = this.computeDelay(referenceTimestamp, next);
      const bytes = [...next.bytes];
      this.cursor++;
      if (delayMs <= 0) {
        this.fireListeners(bytes);
      } else {
        setTimeout(() => this.fireListeners(bytes), delayMs);
      }
    }
  }
  computeDelay(referenceTimestamp, inbound) {
    if (this.latencyMode === "none") return 0;
    if (this.latencyMode === "recorded") {
      return Math.max(0, inbound.timestampMs - referenceTimestamp);
    }
    return Math.max(0, this.latencyMode.fixedMs);
  }
  fireListeners(bytes) {
    for (const cb of [...this.listeners]) {
      cb([...bytes]);
    }
  }
};
function firstByteDiff(expected, actual) {
  const len = Math.max(expected.length, actual.length);
  for (let i = 0; i < len; i++) {
    if (expected[i] !== actual[i]) return i;
  }
  return -1;
}
function formatBytes(bytes) {
  if (bytes.length <= 12) {
    return bytes.map(toHex).join(" ");
  }
  const head = bytes.slice(0, 6).map(toHex).join(" ");
  const tail = bytes.slice(-3).map(toHex).join(" ");
  return `${head} ... ${tail} (${bytes.length} bytes)`;
}
function toHex(b) {
  return `0x${b.toString(16).padStart(2, "0").toUpperCase()}`;
}
export {
  RecordingProxyAdapter,
  SCHEMA_VERSION,
  SimulatedAdapter,
  SimulatedAdapterRecordsExhaustedError,
  SimulatedAdapterUnexpectedSendError,
  appendRecord,
  createScenario,
  parseFixture,
  serializeFixture
};
//# sourceMappingURL=recording.js.map